// Edit Account Phone
export const EDIT_ACCOUNT_PHONE_REQUEST = 'EDIT_ACCOUNT_PHONE_REQUEST';
export const EDIT_ACCOUNT_PHONE_DONE = 'EDIT_ACCOUNT_PHONE_DONE';
export const EDIT_ACCOUNT_PHONE_FAILED = 'EDIT_ACCOUNT_PHONE_FAILED';
export const EDIT_ACCOUNT_PHONE_RESET = 'EDIT_ACCOUNT_PHONE_RESET';